import { CLARITY_ID, IS_PROD } from '../environment'

declare global {
  interface Window {
    clarity?: Function
  }
}

const initClarity = () => {
  if (!CLARITY_ID) {
    return
  }
  // Use the official Clarity snippet — sets up window.clarity queue immediately,
  // then injects the tag script asynchronously
  const snippet = document.createElement('script')
  snippet.type = 'text/javascript'
  snippet.textContent = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window,document,"clarity","script","${CLARITY_ID}");
  `
  document.head.appendChild(snippet)
}

export const initTracking = () => {
  if (!IS_PROD) {
    return
  }

  initClarity()
}



// WEBPACK FOOTER //
// ./src/app/tracking.ts